package one.healthium.profile.ui.update_initial_weight

interface UpdateInitialWeightEvent {
    data object OnInitialWeightUpdated : UpdateInitialWeightEvent
}